module.exports = (function () {
    'use strict';
    const InflatorComps = require('utils/framework/InflateComponents');
    const Events = require('utils/framework/Events');
    const store = require('../store/Store');
    const processUserFull = require('actions/UserActions').processUserFull;
    const urlUtils = require('utils/Url');
    const userUtils = require('utils/User');
    const forceRegisterModal = require('Actions').forceRegisterModal;
    const Storage = require('utils/localStorage/Storage');
    const LOCAL_STORAGE = require('utils/localStorage/Constants');
    const Perf = require('utils/framework/Perf');

    /** Function for Forced Registration Modal if url contains action=register
     * @param {object} userInfoData
     */
    let handleQueryParamsAction = function (userInfoData) {
        let actionParams = urlUtils.getParamsByName('action');

        if (actionParams && actionParams.indexOf('register') > -1) {
            if (userInfoData.profile.profileStatus !== 0 &&
                !userInfoData.profile.beautyInsiderAccount) {
                store.dispatch(forceRegisterModal(true));
            } else if (userInfoData.profile.profileStatus === 0) {
                store.dispatch(forceRegisterModal(false));
            }
        }
    };

    let fetchOrLoadTargeters = function () {
        const {
            getCreditCardTargeters,
            loadCreditCardTargeters
        } = require('actions/CreditCardActions');
        const cachedInfo = Storage.local.getItem(LOCAL_STORAGE.CREDIT_CARD_TARGETERS);
        if (!cachedInfo) {
            store.dispatch(getCreditCardTargeters());
        } else {
            store.dispatch(loadCreditCardTargeters());
        }
    };

    let shouldShowWelcomeMats = function (userInfoData) {
        return userInfoData && userInfoData.profile && userInfoData.profile.welcomeMat;
    };

    /* User Info Service */
    Events.onLastLoadEvent(window, [Events.HydrationFinished, Events.UserInfoLoaded], function () {
        let userInfo = InflatorComps.services.UserInfo;
        let userInfoData = userInfo.data;
        let dataIsFromCache = userInfo.dataIsFromCache;
        store.dispatch(processUserFull(userInfoData, true, dataIsFromCache));

        let isLithiumSignInOrRegister =
            urlUtils.getParamsByName('launchSocialSignInFlow') ||
            urlUtils.getParamsByName('launchSocialRegisterFlow');

        handleQueryParamsAction(userInfoData);

        Events.onLastLoadEvent(
            window,
            [Events.TestTargetReady],
            () => {
                if (!shouldShowWelcomeMats(userInfoData) && !isLithiumSignInOrRegister) {
                    userUtils.forceSignIn();
                }
            }
        );

        fetchOrLoadTargeters();

        InflatorComps.services.loadEvents.UserInfoReady = true;
        window.dispatchEvent(new CustomEvent(Events.UserInfoReady, { detail: {} }));
        Perf.report('UserInfo Ready');

        InflatorComps.renderQueue('UserInfo');
    });

    return null;
}());
